// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--k+9IZ";
export var divider = "style-module--divider--cvAJS";
export var dotsWrapper2 = "style-module--dotsWrapper2--CCSnz";
export var header = "style-module--header--kIjoJ";
export var highlight = "style-module--highlight--sXxWz";
export var img = "style-module--img--yroEu";
export var imgWrapper = "style-module--imgWrapper---1-4S";
export var place = "style-module--place--57n5B";
export var project = "style-module--project--Lr0FV";
export var projectTitle = "style-module--projectTitle--rlkfj";
export var root = "style-module--root--Fea5O";
export var text = "style-module--text--Qd6UW";
export var title = "style-module--title--k0J52";
export var winners = "style-module--winners--V6Hdk";
export var winnersTitle = "style-module--winnersTitle--JOKRW";